import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Fetch } from '../utils/Utils.js';

// field lets this same component serve both relationships stored on births:
// "dam" (the existing mother lookup) and "father" (the sire, resolved by
// reproduction.HandleBirth from the dam's active cycle's bull — see Trello
// #168). damTag is kept as a fallback prop for any caller still using the
// pre-#168 name.
export const Calves = ({ tag, field = 'dam', damTag }) => {
  const { t } = useTranslation();
  const searchTag = tag || damTag;
  const [calves, setCalves] = useState([]);
  const [loading, setLoading] = useState(true);
  const titleKey = field === 'father' ? 'sired_calves' : 'calves';
  const emptyKey = field === 'father' ? 'no_sired_calves' : 'no_calves';

  useEffect(() => {
    if (!searchTag) {
      setLoading(false);
      return;
    }

    Fetch(`api/data/births?search_fields=${field}&search_values=${searchTag}`, "get", null,
      (data) => {
        setCalves(data);
        setLoading(false);
      },
      () => {
        console.log("error loading calves");
        setLoading(false);
      }
    );
  }, [searchTag, field]);

  if (!searchTag) {
    return null;
  }

  if (loading) {
    return (
      <div className="calves-section">
        <h4>{t(titleKey)}</h4>
        <div className="calves-loading">{t('loading')}...</div>
      </div>
    );
  }

  if (calves.length === 0) {
    return (
      <div className="calves-section">
        <h4>{t(titleKey)}</h4>
        <div className="no-calves">{t(emptyKey)}</div>
      </div>
    );
  }

  return (
    <div className="calves-section">
      <h4>{t(titleKey)} ({calves.length})</h4>
      <ul className="calves-list">
        {calves.map((calf, index) => (
          <li key={calf._id || index} className="calf-item">
            <span className="calf-date">{calf.date?.substring(0, 10)}</span>
            <span className="calf-sex">{calf.sex === 'm' ? t('male') : t('female')}</span>
            <span className="calf-breed">{calf.breed}</span>
            {calf.tag && <span className="calf-tag">#{calf.tag}</span>}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Calves;
